<template>
  <li class="comments-item-container">
    <div
      v-if="nextDate"
      class="comments-item-nextdate"
    >
      em {{ nextDate }}
    </div>
    <div :class="commentClasses">
      <div
        v-if="!headless || nextDate"
        class="comments-item-header"
      >
        <img
          :src="avatar"
          alt=""
          class="comments-item-avatar"
        >

        <div class="comments-item-info">
          <h3 class="app-h3">
            {{ comment.user.name | namelize(2) }}
          </h3>

          <h4 class="app-h4 comments-item-date">
            {{ comment.created_at | time }}
          </h4>
        </div>
      </div>

      <p class="comments-item-comment">
        {{ comment.content }}
        <span
          v-if="headless"
          class="comments-item-comment-date"
        >
          {{ comment.created_at | time }}
        </span>
      </p>
      <span class="comments-item-decorator" />
    </div>
  </li>
</template>

<script>
  import userPlaceholder from '@/assets/images/placeholders/user.jpg';

  export default {
    name: 'CommentsItem',
    props: {
      comment: {
        type: Object,
        default() {
          return {
            user: {},
          };
        },
      },
      headless: {
        type: Boolean,
        default: false,
      },
      nextDate: {
        type: String,
        default: '',
      },
      position: {
        type: String,
        default: 'left',
      },
      highlighted: {
        type: Boolean,
        default: false,
      },
    },
    computed: {
      avatar() {
        const {
          user,
        } = this.comment;

        const {
          url,
        } = user.avatar.thumb;

        if (!/^http/.test(url)) {
          return userPlaceholder;
        }

        return url;
      },
      commentClasses() {
        const classes = ['comments-item'];

        if (this.highlighted) {
          classes.push('comments-item-highlighted');
        }

        if (this.nextDate) {
          classes.push('comments-item-outdated');
        }

        if (this.headless && !this.nextDate) {
          classes.push('comments-item-headless');
        }

        if (this.position) {
          classes.push(`comments-item-position-${this.position}`);
        }

        return classes;
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import '@/assets/stylesheets/_variables.scss';

  .comments-item-container {
    align-items: center;
    display: flex;
    flex-direction: column;
    position: relative;
    align-self: flex-start;
    width: 100%;

    &:first-of-type {
      margin-top: $gutter;
    }
  }

  .comments-item {
    background-color: $gray-light;
    border-radius: $button * 0.5;
    margin: $gutter-big 0 0;
    padding: $gutter;
    position: relative;

    & + .comments-item-headless {
      margin-top: $gutter-smallest;
    }
  }

  .comments-item-comment {
    word-break: break-word;
  }

  .comments-item-headless {
    padding-bottom: $gutter-smaller;
    padding-top: $gutter-smaller;
    margin-top: $gutter-smallest;

    .comments-item-comment {
      min-width: $gutter-biggest;

      .comments-item-comment-date {
        display: block;
        font-size: $font-small;
        min-width: $gutter-biggest;
      }
    }
  }

  .comments-item-highlighted {
    background-color: $green;
    color: $white;

    .comments-item-date {
      color: inherit;
    }
  }

  .comments-item-nextdate {
    font-size: $font-small;
    margin-top: $gutter;
    color: $gray;
    background: $gray-light;
    padding: $gutter-smallest $gutter-small;
    border-radius: $gutter-biggest;
  }

  .comments-item-avatar {
    background-color: rgba($gray, 0.2);
    border: 2px solid $white;
    border-radius: 50%;
    height: $button-small;
    width: $button-small;
  }

  .comments-item-position-left {
    align-self: flex-start;

    .comments-item-comment-date {
      color: $gray;
      left: 0;
    }

    .comments-item-avatar {
      margin-right: $gutter-small;
    }
  }

  .comments-item-position-right {
    text-align: right;
    align-self: flex-end;

    .comments-item-comment-date {
      right: 0;
      color: $gray-light;
    }

    .comments-item-avatar {
      order: 1;
      margin-left: $gutter-small;
    }
  }

  .comments-item-header {
    align-items: center;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    margin-bottom: $gutter;

    .comments-item-position-right & {
      justify-content: flex-end;
    }
  }

  .comments-item-decorator {
    border-color: transparent;
    border-right-color: $gray-light;
    border-style: solid;
    border-width: $gutter-small;
    bottom: $gutter - $gutter-smallest;
    left: auto;
    margin-right: -3px;
    position: absolute;
    right: 100%;

    .comments-item-headless & {
      bottom: $gutter-smaller;
      margin-bottom: 6px;
    }

    .comments-item-highlighted & {
      border-right-color: $green;
    }

    .comments-item-position-right & {
      border-color: transparent;
      border-left-color: $gray-light;
      left: 100%;
      margin-left: -3px;
      margin-right: 0;
      right: auto;
    }

    .comments-item-position-right.comments-item-highlighted & {
      border-left-color: $green;
    }
  }
</style>
